/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/mv_like.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns `true` when any value yielded by `field` matches `pattern`, using the same wildcard syntax as `LIKE`.
 * `LIKE` is a single-value scalar: applied to a multivalue field it emits a warning and returns `null`, so this
 * is how you match a wildcard pattern against a multivalue field. A null or empty `field` returns `false`, and
 * because the result is never null the predicate composes under `AND`/`OR`/`NOT`.
 *
 * @example
 * ROW names = ["Anna", "Bob", "Carl"]
 * | EVAL any_starts_with_a = mv_like(names, "A*")
 *
 * @example
 * ROW names = ["Anna", "Bob"]
 * | EVAL has_bo = mv_like(names, "Bo*")
 *
 * @example
 * ROW names = ["Anna", "Bob"]
 * | EVAL no_carl = NOT mv_like(names, "Carl*")
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'mv_like',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'pattern',
          type: 'keyword',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'pattern',
          type: 'text',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'text',
          optional: false,
        },
        {
          name: 'pattern',
          type: 'keyword',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'text',
          optional: false,
        },
        {
          name: 'pattern',
          type: 'text',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
  ],
  preview: true,
  snapshotOnly: false,
};

export default definition;
